module.exports = __webpack_public_path__ + "static/media/IPPF.5a4a0612.png";